module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"open":"Åpne Safen"},"en":{"open":"Open Vault"}}')
  delete Component.options._Ctor
}
